import { RootState } from "@redux/types";

export const featureSongListPlayNowSelector = (state: RootState) =>
	state.featureFlags.songListPlayNow;

export const featureUseNativeKeyboardSelector = (state: RootState) =>
	state.featureFlags.useNativeKeyboard;

export const isCameraActivatedSelector = (state: RootState) =>
	state.featureFlags.isCameraActivated;

export const isVocalalGuideActivatedSelector = (state: RootState) =>
	state.featureFlags.isVocalGuideActivated;

export const isPublicInteractionActivatedSelector = (state: RootState) =>
	state.featureFlags.publicInteraction.isActivated;

export const publicInteractionSelector = (state: RootState) =>
	state.featureFlags.publicInteraction;

export const publicInteractionSingerNameSelector = (state: RootState) =>
	state.featureFlags.publicInteraction.publicSingerName;

export const publicInteractionRoomIdSelector = (state: RootState) =>
	state.featureFlags.publicInteraction.publicRoomId;

export const publicInteractionIsWaitingSongActivatedSelector = (
	state: RootState,
) => state.featureFlags.publicInteraction.isWaitingSongActivated;

export const publicInteractionIsPausedSelector = (state: RootState) =>
	state.featureFlags.publicInteraction.isPaused;

export const vocalEffectsSelector = (state: RootState) =>
	state.featureFlags.vocalEffects;

export const musicEffectsSelector = (state: RootState) =>
	state.featureFlags.musicEffects;

export const isChildSafeSelector = (state: RootState) =>
	state.featureFlags.isChildSafe;

export const isIAPWebcamActivatedSelector = (state: RootState) =>
	state.featureFlags.isIAPWebcamActivated;

export const selectedVocalEffectSelector = (state: RootState) =>
	state.featureFlags.selectedEffect;

export const isPromoTvActivatedSelector = (state: RootState) =>
	state.featureFlags.isTvPromoActivated;

export const isRouletteActivatedSelector = (state: RootState) =>
	state.featureFlags.isRouletteActivated;

export const isBlindTestActivatedSelector = (state: RootState) =>
	state.featureFlags.isBlindTestActivated;

export const isAirconsoleActivatedSelector = (state: RootState) =>
	state.featureFlags.isAirconsoleActivated;

export const isSuggestedTitleActivatedSelector = (state: RootState) =>
	state.featureFlags.isSuggestedTitleActivated;
